// import { method } from "lodash";

const web3Template = (methodCall, param1, param2, param3) => {
  return `{
    "jsonrpc":"2.0",
    "method":"${methodCall}",
    "params":[
      ${String(param1) === "" || String(param1) === "undefined" ? `` : `"${param1}",`}
      ${String(param2) === "undefined" ? `` : `"${param2}",`}
      ${String(param3) === "undefined" ? `` : `"${param3}",`}
    ],
    "id":1
}`;
};

// const web3TraceTemplate = (
//   rpcMethod,
//   methodCall,
//   args,
//   formatters,
//   varName,
//   url
// ) => {
//   return `const Web3 = require("web3");
// // OR import Web3 from 'web3';

// // HTTP version
// (async () => {
//   const web3 = new Web3('${url}');
//   web3.extend({
//     methods: [
//       {
//         name: '${methodCall}',
//         call: '${rpcMethod}',
//         params: ${formatters.length},
//         inputFormatter: [${formatters.join(', ')}],
//       },
//     ],
//   });
//   const ${varName} = await web3.${methodCall}('${args.join("', '")}');
//   console.log(${varName});
// })();
// `;
// };

// const contractTemplate = (url, args) => {
//   const [address, abi, method, methodArgumentsString] = args;
//   return `const Web3 = require("web3");
// // OR import Web3 from 'web3';

// // HTTP version
// (async () => {
//   const abi = ${abi && JSON.stringify(abi)}
//   const web3 = new Web3('${url}');
//   const contract = new web3.eth.Contract(abi, '${address}');
//   const response = await contract.methods.${method}(${methodArgumentsString});
//   console.log(response);
// })();`;
// };

// const contractTraceTemplate = (url, args) => {
//   const [
//     traceTypeList,
//     block,
//     from,
//     value,
//     contract,
//     abi,
//     method,
//     methodArgumentsString,
//   ] = args;
//   return `const Web3 = require("web3");
// // OR import Web3 from 'web3';

// // HTTP version
// (async () => {
//   const abiFragment = ${abi && JSON.stringify(abi[0])}
//   const web3 = new Web3('${url}');
//   const data = web3.eth.abi.encodeFunctionCall(abiFragment, [${methodArgumentsString}]);${from ? `\n  const from = "${from}";` : ''
//     }
//   const to = "${contract}"; ${value ? `\n  const value = "${value}";` : ''}
//   const transaction = { ${from ? `\n    from,` : ''}
//     to,${value ? `\n    value,` : ''}
//     data,
//   };
//   web3.extend({
//     methods: [
//       {
//         name: 'parityTraceCall',
//         call: 'trace_call',
//         params: 3,
//         inputFormatter: [null, null, null],
//       },
//     ],
//   });
//   const response = await web3.parityTraceCall(transaction, ${traceTypeList}, ${block});
//   console.log(response);
// })();`;
// };

// const filterTemplate = (url, filterMethod, filter) => {
//   return `const Web3 = require("web3");
// // OR import Web3 from 'web3';
// ${filter ? `\n${filter}\n` : ''}
// // HTTP version
// (async () => {
//   const web3 = new Web3('${url}');
//   web3.extend({
//     methods: [
//       {
//         name: '${filterMethod}',
//         call: '${filterMethod}',
//         params: ${filter ? 1 : 0},
//         inputFormatter: [${filter ? 'null' : ''}],
//       },
//     ],
//   });
//   web3.extend({
//     methods: [
//       {
//         name: 'eth_getFilterChanges',
//         call: 'eth_getFilterChanges',
//         params: 1,
//         inputFormatter: [null],
//       },
//     ],
//   });
//   const filterId = await web3.${filterMethod}(${filter ? 'filter' : ''});
//   console.log(filterId);
//   const response = await web3.eth_getFilterChanges(filterId);
//   console.log(response);
// })();`;
// };

const Web3JSCalls = {
  eth_syncing: {
    exec: (provider, proto, ...args) => {
      return provider.eth.isSyncing();
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_syncing`,
      );
    },
    args: [],
  },
  eth_hashrate: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getHashrate();
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_hashrate`);
    },
    args: [],
  },
  eth_gasPrice: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getGasPrice();
    },
    codeSample: (url, ...args) => {
      return web3Template(`eth_gasPrice`);
    },
    args: [],
  },
  eth_accounts: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getAccounts();
    },
    codeSample: (url, ...args) => {
      return web3Template(`eth_accounts`);
    },
    args: [],
  },
  eth_blockNumber: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlockNumber();
    },
    codeSample: (url, ...args) => {
      return web3Template(`eth_blockNumber`);
    },
    args: [],
  },
  eth_getBalance: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBalance(args[0], args[1]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getBalance`,
        `${args[0]}`,
        `${args[1]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Address to check for balance',
        placeholder: 'i.e. 0x91b51c173a4...',
      },
      {
        type: 'textfield',
        description:
          'Hex block number, or the string "latest", "earliest" or "pending"',
        placeholder: 'i.e. latest or pending',
      },
    ],
  },
  eth_getStorageAt: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getStorageAt(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getStorageAt`,
        `${args[0]}`,
        `${args[1]}`,
        `${args[2]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Address of the storage',
        placeholder: 'i.e. 0x91b51c173a4... or ENS domain',
      },
      {
        type: 'textfield',
        description: 'Hex of the position in the storage',
        placeholder: 'i.e. 0x0, 0x1, 0x2...',
      },
      {
        type: 'textfield',
        description:
          'Hex block number, or the string "latest", "earliest" or "pending"',
        placeholder: 'i.e. latest or pending',
      },
    ],
  },
  eth_getTransactionCount: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getTransactionCount(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getTransactionCount`,
        `${args[0]}`,
        `${args[1]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Address to check for balance',
        placeholder: 'i.e. 0x91b51c173a4...',
      },
      {
        type: 'textfield',
        description:
          'Hex block number, or the string "latest", "earliest" or "pending"',
        placeholder: 'i.e. latest or pending',
      },
    ],
  },
  eth_getBlockTransactionCountByHash: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlockTransactionCount(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getBlockTransactionCountByHash`,
        `${args[0]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a block to get transaction count from',
        placeholder: 'i.e. 0x16c4e370736...',
      },
    ],
  },
  eth_getBlockTransactionCountByNumber: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlockTransactionCount(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getBlockTransactionCountByNumber`,
        `${args[0]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description:
          'Integer in decimal format of a block to get transaction count from',
        placeholder: 'i.e. 10674793',
      },
    ],
  },
  eth_getCode: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getCode(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getCode`,
        `${args[0]}`,
        `${args[1]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Address to fetch code from',
        placeholder: 'i.e. 0x91b51c173a4...',
      },
      {
        type: 'textfield',
        description:
          'Integer block number, or the string "latest", "earliest" or "pending"',
        placeholder: 'i.e. latest or pending',
      },
    ],
  },
  eth_sendRawTransaction: {
    exec: (provider, proto, ...args) => {
      return provider.eth.sendSignedTransaction(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_sendRawTransaction`,
        `${args[0]}`,
        );
    },
    args: [
      {
        type: 'textarea',
        description: 'The previously signed transaction data',
        placeholder:
          'i.e. 0xd46e8dd67c5d32be8d46e8dd67c5d32be8058bb8eb970870f072445675058bb8eb970870f072445675',
      },
    ],
  },

  // Supported in Web3API, but doesn't work here

  // eth_call: {
  //   exec: (provider, proto, ...args) => {
  //     const [address, abi, method, ...rest] = args;
  //     try {
  //       const contract = new provider.eth.Contract(JSON.parse(abi), address);
  //       return contract.methods[method](...rest).call();
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   },
  //   codeSample: (url, ...args) => {
  //     return contractTemplate(url, args);
  //   },
  //   args: [
  //     {
  //       type: 'textarea',
  //       description: 'Address of contract',
  //       placeholder: 'i.e. 0x91b51c173a4...',
  //     },
  //     {
  //       type: 'textarea',
  //       description: 'Contract ABI (URL or single function object)',
  //       placeholder:
  //         'i.e. [{"inputs":[{"name":"chainId...\nOR\nhttps://raw.githubusercontent.com/.../build/contracts/ERC20.json',
  //     },
  //     {
  //       type: 'dropdown',
  //       description: 'Function name (READ only)',
  //     },
  //   ],
  // },

  // Supported in Web3API, but doesn't work here

  // eth_estimateGas: {
  //   exec: (provider, proto, ...args) => {
  //     return new Promise((resolve, reject) =>
  //       reject('EtherFlow does not support this method.')
  //     );
  //   },
  //   codeSample: (url, ...args) => {
  //     return '/* Not Supported by EtherFlow */';
  //   },
  //   args: [],
  // },

  eth_getBlockByHash: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlock(args[0], args[1] === 'true');
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getBlockByHash`,
        `${args[0]}`,
        `false`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a block to get information from',
        placeholder: 'i.e. 0x16c4e370736...',
      },
      {
        type: 'boolean',
        description: 'Return full transaction objects',
        placeholder: '',
      },
    ],
  },
  eth_getBlockByNumber: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlock(args[0], args[1] === 'true');
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getBlockByNumber`,
        `${args[0]}`,
        `false`,
      );
    },
    args: [
      {
        type: 'textarea',
        description:
          'Integer in decimal format of a block number to get information from',
        placeholder: 'i.e. 10674793',
      },
      {
        type: 'boolean',
        description: 'Return full transaction objects',
        placeholder: '',
      },
    ],
  },
  eth_getTransactionByHash: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getTransaction(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getTransactionByHash`,
        `${args[0]}`,
        );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a transaction to get information for',
        placeholder:
          'i.e. 0x95575ee5f6cdb3907cd2983516f33828855ed4f12320103dc8524b96a5a5414b',
      },
    ],
  },
  eth_getTransactionByBlockHashAndIndex: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getTransactionFromBlock(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getTransactionByBlockHashAndIndex`,
        `${args[0]}`,
        `${args[1]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a block to get information from',
        placeholder: 'i.e. 0x16c4e370736...',
      },
      {
        type: 'textfield',
        description: 'Integer in decimal format of tx position in the block',
        placeholder: 'i.e. 0, 1, 2...',
      },
    ],
  },
  eth_getTransactionByBlockNumberAndIndex: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getTransactionFromBlock(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getTransactionByBlockNumberAndIndex`,
        `${args[0]}`,
        `${args[1]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description:
          'Integer in decimal format, or the string "latest", "earliest" or "pending"',
        placeholder: 'i.e. 10674793',
      },
      {
        type: 'textfield',
        description: 'Integer in decimal format of tx position in the block',
        placeholder: 'i.e. 0, 1, 2...',
      },
    ],
  },
  eth_getTransactionReceipt: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getTransactionReceipt(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getTransactionReceipt`,
        `${args[0]}`,  
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a transaction to get information for',
        placeholder:
          'i.e. 0x95575ee5f6cdb3907cd2983516f33828855ed4f12320103dc8524b96a5a5414b',
      },
    ],
  },
  eth_getUncleByBlockHashAndIndex: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getUncle(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getUncleByBlockHashAndIndex`,
        `${args[0]}`,  
        `${args[1]}`,  
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a block to get information from',
        placeholder: 'i.e. 0x16c4e370736...',
      },
      {
        type: 'textfield',
        description: 'The uncle’s index position as an integer.',
        placeholder: 'i.e. 0, 1, 2...',
      },
    ],
  },
  eth_getUncleByBlockNumberAndIndex: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getUncle(...args);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getUncleByBlockNumberAndIndex`,
        `${args[0]}`,  
        `${args[1]}`, 
      );
    },
    args: [
      {
        type: 'textarea',
        description:
          'Integer in decimal format of a block to get transaction count from',
        placeholder: 'i.e. 10674793',
      },
      {
        type: 'textfield',
        description: 'The uncle’s index position as an integer.',
        placeholder: 'i.e. 0, 1, 2...',
      },
    ],
  },
  eth_getUncleCountByBlockHash: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlockUncleCount(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getUncleCountByBlockHash`,
        `${args[0]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description: 'Hash of a block to get uncle count from',
        placeholder: 'i.e. 0x16c4e370736...',
      },
    ],
  },
  eth_getUncleCountByBlockNumber: {
    exec: (provider, proto, ...args) => {
      return provider.eth.getBlockUncleCount(args[0]);
    },
    codeSample: (url, ...args) => {
      return web3Template(
        `eth_getUncleCountByBlockNumber`,
        `${args[0]}`,
      );
    },
    args: [
      {
        type: 'textarea',
        description:
          'Integer in decimal format of a block to get uncle count from',
        placeholder: 'i.e. 10674793',
      },
    ],
  },
};

export default Web3JSCalls;
